import React from 'react';

import HomeCatalog from './HomeCatalog';
import ShopAdvantages from './ShopAdvantages';
import HomeReviews from './HomeReviews';
import ViewedProducts from './ViewedProducts';

const HomePage = () => (
  <>
    <HomeCatalog />
    <ShopAdvantages />
    <HomeReviews />
    <ViewedProducts />
  </>
);

export default HomePage;
